export const styles = theme => ({
    root: {
        height: "100%",
        paddingTop: "44px",
        flexWrap: "wrap",
        background: `linear-gradient(to top, rgba(157, 167, 233, 0.6),rgba(157, 167, 233, 0.75), rgba(157, 167, 233, 0.9), rgba(157, 167, 233, 1))`
    }
});